export const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '',
  disabled = false,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 font-semibold rounded-xl transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:translate-y-[1px] motion-reduce:transition-none motion-reduce:transform-none min-h-[48px] touch-manipulation select-none';
  
  const variants = {
    primary: 'bg-gradient-to-b from-primary-500 to-primary-700 text-white shadow-[0_10px_20px_-10px_rgba(107,63,31,0.7)] hover:brightness-105 focus-visible:ring-primary-500',
    secondary: 'bg-gradient-to-b from-secondary-400 to-secondary-600 text-neutral-900 shadow-[0_10px_20px_-10px_rgba(169,134,61,0.6)] hover:brightness-105 focus-visible:ring-secondary-500',
    outline: 'border border-neutral-300 dark:border-neutral-700 bg-white/85 dark:bg-neutral-800/85 text-neutral-700 dark:text-neutral-100 hover:bg-neutral-100 dark:hover:bg-neutral-700/90 focus-visible:ring-primary-500',
    ghost: 'text-primary-700 dark:text-primary-300 hover:bg-primary-100/70 dark:hover:bg-primary-900/30 focus-visible:ring-primary-500 shadow-none',
  };

  const sizes = {
    sm: 'px-3.5 py-2 text-sm min-h-[44px]',
    md: 'px-5 py-2.5 text-sm sm:text-base min-h-[48px]',
    lg: 'px-6 py-3 text-base sm:text-lg min-h-[52px]',
  };

  const variantClass = variants[variant] || variants.primary;
  const sizeClass = sizes[size] || sizes.md;

  return (
    <button 
      className={`${baseClasses} ${variantClass} ${sizeClass} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
